import React from "react";
import OutputGoods from "./OutputGoods";
import "./billOfMaterial.scss";
import {
  BomHeaderType,
  BomInstallationType,
  BomOutputType,
  BomTotalType,
  SelectOption,
} from "../../../../commonTypes/billOfMaterial";
import { changeToDecimel } from "../../../../utils/commonFunctions";

type AppProps = {
  outputData: BomOutputType[];
  addMoreData: (type: string) => void;
  branchOption: SelectOption[];
  currencySign: string | undefined;
  allStockItemOption: SelectOption[];
  total: {
    input: BomTotalType;
    output: BomTotalType;
    totalAdditionalCost?: number;
  };
  setTotal: React.Dispatch<
    React.SetStateAction<{
      input: BomTotalType;
      output: BomTotalType;
      totalAdditionalCost?: number;
    }>
  >;
  deleteData: (type: string, index: number) => void;
  bomInstallationData: BomInstallationType[];
  bomHeaderData: BomHeaderType;
  fetching: boolean;
  checkStockItemTypeBottom: () => void;
  setStockItemText: any;
  templateId?: string;
  setBomInstallationData: React.Dispatch<
    React.SetStateAction<BomInstallationType[]>
  >;
  setBomHeaderData: React.Dispatch<React.SetStateAction<BomHeaderType>>;
  setBomTempHeaderData: React.Dispatch<React.SetStateAction<BomHeaderType>>;
  handleEditInstallation: (id: number) => void;
  handleInstallationChange: (e: any, id: number) => void;
  handletoggleRowInput: (item: number, data: any)
    => void;
  handleInputChange: (
    e: any,
    type: string,
    inputType: string,
    index: number
  ) => void;
  autoUniqueNumberGenerationData: any;
  toggleExpandCollapseItems: (type: string, action: string) => void;
  handleGetSelectedbatch: (data1: any, data2: any, type: string) => void;
  batchFetching:boolean;
  isMenuOpen:boolean;
};

const BomOutput = ({
  total,
  branchOption,
  outputData,
  addMoreData,
  deleteData,
  fetching,
  currencySign,
  checkStockItemTypeBottom,
  setStockItemText,
  bomHeaderData,
  templateId,
  allStockItemOption,
  handleInputChange,
  handletoggleRowInput,
  handleGetSelectedbatch,
  autoUniqueNumberGenerationData,
  toggleExpandCollapseItems,
  batchFetching,
  isMenuOpen
}: AppProps) => {
  return (
    <div className="bomOutput">
      <div className="output">
        <OutputGoods
          currencySign={currencySign}
          allStockItemOption={allStockItemOption}
          branchOption={branchOption}
          fetching={fetching}
          templateId={templateId}
          checkStockItemTypeBottom={checkStockItemTypeBottom}
          setStockItemText={setStockItemText}
          outputData={outputData}
          addMoreData={addMoreData}
          deleteData={deleteData}
          bomHeaderData={bomHeaderData}
          handleInputChange={handleInputChange}
          handletoggleRowInput={handletoggleRowInput}
          handleGetSelectedbatch={handleGetSelectedbatch}
          autoUniqueNumberGenerationData={autoUniqueNumberGenerationData}
          toggleExpandCollapseItems={toggleExpandCollapseItems}
          batchFetching={batchFetching}
          isMenuOpen={isMenuOpen}
        />
      </div>

      <div className="totalAmount">
        <div className="totalQty" style={{ paddingLeft: "44%" }}>{`${outputData?.length === 0
          ? 0
          : !!total?.output?.qty
            ? changeToDecimel(+total?.output?.qty)
            : 0
          } Qty`}</div>

        <div className="totalAmt">
          {currencySign}{" "}
          {!!total?.output?.amount
            ? changeToDecimel(+total?.output?.amount)
            : 0}
        </div>
      </div>
    </div>
  );
};

export default BomOutput;
